import React from "react"
import "./styles.scss"
import TLink from "../../transitions/TLink"
import ProjectSingle from "../../molecules/ProjectSingle"

const ProjectsList = ({ projects, isDesktop, infoTitle, infoDescription }) => {
  return (
    <section className="section section--projects">
      <div className="wrapper--text">
        <ul className="projects">
          {projects.map((project, i) => {
            return (
              <ProjectSingle
                delay={`${(i / 1) * 0.1}s`}
                key={project.id + i}
                project={project}
                isDesktop={isDesktop}
              />
            )
          })}
          {/* {infoTitle && infoDescription && (
            <li className="projects__info project">
              <h2 className="projects__info-title">{infoTitle}</h2>
              <p
                className="projects__info-description"
              >These are just a dozen of the best projects out of 50+ that we have completed so far. We are constantly working on building new products. <TLink
                className="projects__info-link btn--bordered"
                to="/contact/"
              >Drop us a line</TLink> so we can tell you more about our recent work.</p>
            </li>
          )} */}
        </ul>
      </div>
    </section>
  )
}

export default ProjectsList
